import React from "react";

import Cube from "components/measuring/components/cube";
import { transformDimension } from "../../helpers";
import { lbsCode, ozCode } from "./consts";
import { WeightTransformer } from "./weight-transformer";

export const MeasurementsBox = ({ dimensions, label, uom }) => {
    const isLbs = uom?.weight === lbsCode;
    const isOz = uom?.weight === ozCode;

    const uomHTML =
        uom.width === uom.height && uom.width === uom.depth ? (
            <li className="-dimensions">
                <div className="background-line">
                    <span>{uom["width"]}</span>
                </div>
            </li>
        ) : (
            Object.keys(uom).reduce((arr, k) => {
                if (k !== "weight") {
                    arr.push(
                        <li>
                            <div className="background-line">
                                <span>{uom[k]}</span>
                            </div>
                        </li>
                    );
                }

                return arr;
            }, [])
        );

    return (
        <div>
            <ul className="stats">
                <li></li>
                <li>
                    <Cube dimensions={dimensions} />
                </li>
                <li>
                    <h2>{transformDimension(dimensions.height)}</h2>
                    <p>Height</p>
                </li>
                <li>
                    <h2>{transformDimension(dimensions.width)}</h2>
                    <p>Width</p>
                </li>
                <li>
                    <h2>{transformDimension(dimensions.depth)}</h2>
                    <p>Depth</p>
                </li>
                <li>
                    <h2>{transformDimension(dimensions.weight)}</h2>
                    <p>Weight</p>
                </li>
                <li className="-vertical -no-margin">{label}</li>
                <li></li>
                <li></li>
                {uomHTML}
                <li>
                    <div className="background-line">
                        <span>{uom.weight}</span>
                    </div>
                </li>
                <li></li>
            </ul>
            <WeightTransformer
                className="m-r-80"
                isOz={isOz}
                isLbs={isLbs}
                weight={dimensions.weight}
            />
        </div>
    );
};
